import styled from '@/styles';

export const Backdrop = styled('div', {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.45)',
  zIndex: 600,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 24,
  fontFamily: "'Manrope', sans-serif",
});

export const ModalCard = styled('div', {
  background: '#fff',
  borderRadius: 12,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  variants: {
    size: {
      browse: { maxWidth: 640, maxHeight: '85vh', overflowY: 'auto' },
      save: { maxWidth: 540 },
    },
  },
});

export const HeaderRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  variants: {
    layout: {
      back: {
        gap: 12,
        padding: '20px 24px 16px',
        borderBottom: '1px solid #EAEAEA',
      },
      between: {
        justifyContent: 'space-between',
        padding: '20px 24px 0',
      },
    },
  },
});

export const HeaderTitle = styled('h2', {
  fontSize: 17,
  fontWeight: 700,
  color: '#1C1C1C',
  margin: 0,
  fontFamily: "'Manrope', sans-serif",
  variants: {
    size: {
      md: { fontSize: 17 },
      lg: { fontSize: 18 },
    },
  },
});

export const IconButton = styled('button', {
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  color: '#1C1C1C',
  variants: {
    pad: {
      sm: { padding: 4 },
    },
  },
});

export const FooterRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 16,
  padding: '16px 24px',
  borderTop: '1px solid #EAEAEA',
  flexShrink: 0,
});

export const TextLink = styled('button', {
  background: 'transparent',
  border: 'none',
  color: '#2E8722',
  fontSize: 14,
  fontWeight: 600,
  fontFamily: "'Manrope', sans-serif",
  cursor: 'pointer',
  height: 40,
  padding: '0 20px',
  borderRadius: 8,
  '&:disabled': { opacity: 0.5, cursor: 'not-allowed' },
});

export const PrimaryAction = styled('button', {
  background: '#44A735',
  color: '#fff',
  border: 'none',
  borderRadius: 8,
  height: 40,
  padding: '0 28px',
  fontSize: 14,
  fontWeight: 700,
  fontFamily: "'Manrope', sans-serif",
  cursor: 'pointer',
  boxShadow: '0 2px 4px rgba(0,0,0,0.12)',
  '&:hover': { background: '#2E8722' },
  '&:disabled': { opacity: 0.5, cursor: 'not-allowed', background: '#9DC97A' },
});
